<template lang="pug">
modal-window.modal-branch-edit(:title='title', ref='modalWindow')
  .modal-branch-edit__inner(v-if='branchEditData')
    .modal-branch-edit__inner__body(ref='modalBody')
      .modal-branch-edit__inner__body__error
        .modal-branch-edit__inner__body__error__message.text-small(v-for='message in errorMessages') {{ message }}
      .modal-branch-edit__inner__body__item
        .modal-branch-edit__inner__body__item__label.text-small(v-if='isUpdate')
          slot(name='academyNameDisabledLabel')
        .modal-branch-edit__inner__body__item__label.text-small(v-else)
          slot(name='academyNameLabel')
        pulldown-select.modal-branch-edit__inner__body__item__select(
          v-model='branchEditData.academyId',
          :selectOptions='academySelectOptions',
          :disabled='isUpdate'
        )
      .modal-branch-edit__inner__body__item
        .modal-branch-edit__inner__body__item__label.text-small
          slot(name='branchNameLabel')
        textbox-setting.modal-branch-edit__inner__body__item__input(
          v-model='branchEditData.branchName',
          :placeholder='branchNamePlaceholder'
        )
      .modal-branch-edit__inner__body__item
        .modal-branch-edit__inner__body__item__label.text-small(v-if='isUpdate')
          slot(name='branchCodeDisabledLabel')
        .modal-branch-edit__inner__body__item__label.text-small(v-else)
          slot(name='branchCodeLabel')
        textbox-setting.modal-branch-edit__inner__body__item__input(
          v-model='branchEditData.branchCode',
          :placeholder='branchCodePlaceholder',
          :disabled='isUpdate'
        )
    .modal-branch-edit__inner__footer
      button-modal-keep.modal-branch-edit__inner__footer__button(@click='keep')
        slot(name='keepText')
</template>

<script lang="ts">
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import ModalWindow from '@/components/molecules/manager/ModalWindow.vue'
import PulldownSelect from '@/components/molecules/manager/PulldownSelect.vue'
import TextboxSetting from '@/components/molecules/manager/TextboxSetting.vue'
import ButtonModalKeep from '@/components/molecules/manager/ButtonModalKeep.vue'
import { BranchEditType } from '@/models/branchListModel'
import { InputItem } from '@/models/inputItem'

/**
 * 教室管理編集モーダル
 */
@Component({
  components: {
    ModalWindow,
    PulldownSelect,
    TextboxSetting,
    ButtonModalKeep,
  },
})
export default class ModalBranchEdit extends Vue {
  // モーダルのタイトル
  @Prop()
  title!: string

  // 編集対象の教室情報
  @Prop()
  branchEditData?: BranchEditType

  // 塾名選択プルダウンのオプション
  @Prop()
  academySelectOptions!: InputItem[]

  // 教室名プレースホルダー
  @Prop()
  branchNamePlaceholder!: string

  // 教室コードプレースホルダー
  @Prop()
  branchCodePlaceholder!: string

  // 保存ボタン押下時イベント
  @Prop()
  keepButtonEvent!: Function

  // エラーメッセージ
  @Prop()
  errorMessages!: string[]

  // モーダルウィンドウのRef
  @Ref()
  modalWindow!: ModalWindow

  // 入力エリア部のHTLMエレメント
  @Ref()
  modalBody!: HTMLElement

  // 保存処理
  private async keep() {
    await this.keepButtonEvent()
    if (this.errorMessages.length > 0) {
      // エラーメッセージがある場合は入力エリア部のトップまでスクロール
      this.modalBody.scrollTo({ top: 0 })
    } else {
      this.modalWindow.hide()
    }
  }

  public show() {
    this.modalWindow.show()
  }

  // 更新処理であるか
  private get isUpdate(): boolean {
    return !!this.branchEditData?.id
  }
}
</script>

<style lang="stylus" scoped>
.modal-branch-edit
  &__inner
    display flex
    height 463px
    flex-direction column
    align-items flex-start
    gap 20px

    &__body
      display flex
      flex-direction column
      gap 12px
      overflow-y auto

      &__error
        &__message
          color var(--color-manager-modal-alert__text)

      &__item
        width 100%
        display flex
        flex-direction column
        gap 12px

        &__select
          width 100%

    &__footer
      margin-top auto
</style>
